let mTranscript:any;
export function initTranscript(db:any){
    mTranscript = db.table('transcript');
}

export function getTransctiptById(szId:any){
    return mTranscript.get(szId);
}

export function updateTranscript(transcript:any){
    return mTranscript.put(transcript);
}

export function batchUpdateTranscripts(arrayTranscripts){
    return mTranscript.bulkPut(arrayTranscripts);
}